import { render } from "./OnInLays.vue?vue&type=template&id=658ffd0b"
import script from "./OnInLays.vue?vue&type=script&lang=js"
export * from "./OnInLays.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__